<script setup lang="ts">
import { Icon } from '#components';
import type { IconSize } from '.';

defineProps<{
  name: `${string}:${string}`;
  size: IconSize;
}>();
</script>

<template>
  <Icon
    :name
    :class="{
      'size-3': size === 'xs',
      'size-5': size === 'sm',
      'size-6': size === 'md',
    }"
  />
</template>
